<template>
    <div :class="colClass" class="mb-5">
        <div class="document-teaser">
            <router-link :to="{name: 'document.detail', params: {id: document.id}}">
                <div v-if="showCategory && category" class="category">{{category.title}}</div>
                <h3>{{ document.title }}</h3>
                <p v-html="document.teaser"></p>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DocumentTeaser",
        props: {
            id: null,
            colClass: null,
            showCategory: {
                default: true,
            }
        },

        computed: {
            document() {
                return this.$store.getters.documentById(this.id)
            },

            category() {
                return this.$store.getters.categoryById(this.document.categoryId);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .document-teaser {
        padding: 1.5rem;
        background: #fff;

        border: 1px #eee solid;
        border-radius: 5px;

        box-shadow: 1px 1px 3px rgba(0, 0, 0, .1);

        color: inherit;
    }


    .document-teaser a {
        color: #111;
        text-decoration: none;
    }

    .document-teaser h3 {
        color: #111;
        text-decoration: none;
        margin-bottom: 10px;

        font-size: 1.8rem;
        font-weight: normal;
        margin-top: 1.0rem;
    }

    .document-teaser p {
        font-size: 1.4rem;
    }

    .document-teaser .category {
        background-color: #efefef;
        padding: 5px 8px;
        font-size: 1.0rem;

        display: inline-block;
        border-radius: 5px;
    }
</style>